module.exports = __webpack_public_path__ + "15f06d84059536dd7f19f7e734403d39.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GA.svg
// module id = fqqb
// module chunks = 0